import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, mergeMap, tap } from 'rxjs/operators';
import * as main from './main.actions';
import { concat, Observable, of } from 'rxjs';
import { from } from 'rxjs/internal/observable/from';
import { HttpService } from '../../global/http.service';
import { Client, ResourceRequestPayload, StaticDataPayload } from './main.models';
import { StaticData, EmptyResponse, PageNotes, CountryStaticData } from '../../global/interfaces';
import { Actions as ActionsCDK } from 'atlas-cdk';
import { ToastService } from '../toaster_/toaster_.service';

@Injectable()
export class MainEffects {
  public loadMainClients$ = createEffect(() => this.actions$.pipe(
    ofType<main.LoadMainClientsAction>(main.ActionTypes.LOAD_MAIN_CLIENTS),
    map(action => action.payload),
    switchMap((payload) =>
      this.loadClients(payload).pipe(
        map((response: Client[]) =>
          new main.LoadMainClientsSuccessAction(response)
        ),
        catchError(() =>
        (from([
          new main.LoadMainClientsFailedAction()
        ])
        ))
      )
    )
  ));

  public loadStaticData$ = createEffect(() => this.actions$.pipe(
    ofType<main.LoadStaticDataAction>(main.ActionTypes.LOAD_STATIC_DATA),
    switchMap(({ payload }) =>
      this.loadStaticData(payload).pipe(
        map((response: StaticData) =>

          new main.LoadStaticDataSuccessAction(response)
        ),
        catchError(() =>
          // from([
          //   new main.LoadStaticDataFailedAction(),
          //   new AddErrorToastAction(`Investor Portal is currently unavailable
          //     - please login again shortly. Contact the Helpdesk if you require immediate support`)
          // ])
          // {
          //   this._toasterService.launchAlertError(`Investor Portal is currently unavailable
          //     - please login again shortly. Contact the Helpdesk if you require immediate support`, ActionsCDK.error);
          //   return of(new main.LoadStaticDataFailedAction());
          // }
          concat(
            of(new main.LoadStaticDataFailedAction()),
            of(null).pipe(
              tap(() => {
                this._toasterService.launchAlertError(`Investor Portal is currently unavailable
            - please login again shortly. Contact the Helpdesk if you require immediate support`, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  public loadLoginContactUs$ = createEffect(() => this.actions$.pipe(
    ofType<main.LoadLoginContactUsAction>(main.ActionTypes.LOAD_LOG_IN_CONTACT_US),
    switchMap(() =>
      this.loadLoginContactUs().pipe(
        map((response: CountryStaticData[]) =>
          new main.LoadLoginContactUsSuccessAction(response)
        ),
        catchError((error) =>
          // from([
          //   new main.LoadLoginContactUsFailedAction(),
          //   new AddErrorToastAction(`Investor Portal is currently unavailable
          //     - please login again shortly. Contact the Helpdesk if you require immediate support`)
          // ])
          // {
          //   this._toasterService.launchAlertError(`Investor Portal is currently unavailable
          //     - please login again shortly. Contact the Helpdesk if you require immediate support`, ActionsCDK.error);
          //   return of(new main.LoadLoginContactUsFailedAction());
          // }
          concat(
            of(new main.LoadLoginContactUsFailedAction()),
            of(null).pipe(
              tap(() => {
                this._toasterService.launchAlertError(`Investor Portal is currently unavailable
            - please login again shortly. Contact the Helpdesk if you require immediate support`, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));
  public loadPageNotes$ = createEffect(() => this.actions$.pipe(
    ofType<main.LoadPageNotesAction>(main.ActionTypes.LOAD_PAGE_NOTES),
    switchMap(() =>
      this.loadPageNotes().pipe(
        map((response: PageNotes) =>
          new main.LoadPageNotesSuccessAction(response)
        ),
        catchError(() =>
        (from([
          new main.LoadPageNotesFailedAction()
        ])
        ))
      )
    )
  ));

  public setStaticData$ = createEffect(() => this.actions$.pipe(
    ofType<main.SetStaticDataAction>(main.ActionTypes.SET_STATIC_DATA),
    switchMap(({ payload }) =>
      this.setStaticData(payload).pipe(
        mergeMap(() =>
        (from([
          new main.SetStaticDataSuccessAction(payload),
          //new AddSuccessToastAction('Changes Applied')
        ]).pipe(
          tap(() => {
            this._toasterService.launchAlertSuccess('Changes Applied', ActionsCDK.success);
          })
        )

        )),
        catchError(() =>
        (from([
          new main.SetStaticDataFailedAction()
        ])
        ))
      )
    )
  ));

  public createResourceRequest$ = createEffect(() => this.actions$.pipe(
    ofType<main.CreateResourceRequestAction>(main.ActionTypes.CREATE_RESOURCE_REQUEST),
    switchMap(({ payload }) =>
      this.createResourceRequest(payload).pipe(
        mergeMap(() =>
          (from([
            new main.CreateResourceRequestSuccessAction(payload),
            // new AddSuccessToastAction('The request has been submitted successfully.')
          ])).pipe(
            tap(() => {
              this._toasterService.launchAlertSuccess('The request has been submitted successfully.', ActionsCDK.success);
            }))

        ),
        catchError(() =>
        (from([
          new main.CreateResourceRequestFailedAction()
        ])
        ))
      )
    )
  ));

  public constructor(
    private readonly actions$: Actions,
    private readonly http: HttpService,
    private readonly _toasterService: ToastService
  ) {
  }

  private loadClients(payload): Observable<Client[]> {
    return this.http.get(`/clients/consultant?country=${payload.country}`);
  }

  private loadStaticData(country?: string): Observable<StaticData> {
    const url = country ? `/static-data/${country}` : '/static-data';
    return this.http.get(url, { withCredentials: false });
  }

  private loadLoginContactUs(): Observable<any> {

    return this.http.get('/static-data/login/contact-us', { withCredentials: false });
  }
  private loadPageNotes(): Observable<PageNotes> {
    return this.http.get('/static-data/page-notes', { withCredentials: true });
  }

  private setStaticData(payload: StaticDataPayload[]): Observable<EmptyResponse> {
    return this.http.put('/admin/static-data', payload, { withCredentials: true });
  }

  private createResourceRequest(payload: ResourceRequestPayload): Observable<EmptyResponse> {
    return this.http.post('/admin/submitRequest', payload);
  }

}
